import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate, getRecords } from "../../services/api.service.js";
import "react-toastify/dist/ReactToastify.css";
import { createPageData, basicFormData } from "./OutgoingInvoicesFile.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../Style/loaderOverly.js";
import { AvForm } from "availity-reactstrap-validation";
import { LoaderCreatePage } from "../Loader/Loader.js";
const OutgoingInvoicesView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, getEndpoint } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  const getEditData = async (id) => {
    try {
      let payload = {
        // modelName: initialPayload?.modelName,
        // schema: initialPayload?.schema,
        // include: initialPayload?.include,
      };
      if (id) {
        payload = { invoice_id: id };
      }
      const responseData = await getRecords(payload, "/invoice/view");

      if (responseData?.data) {
        const data = responseData?.data;

        setFormData({ inputData: data });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Outgoing Invoice Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                        </div>
                        {/* ================= INVOICE DETAILS ================= */}
                        <div className="mt-2 mb-2 p-3 border rounded bg-light">
                          <h5 className="fw-bold mb-3">Invoice Details</h5>

                          <Row>
                            <Col md="4">
                              <p>
                                <strong>Outgoing Invoice No: </strong>
                                {formData?.inputData?.invoice?.invoice_number ||
                                  "-"}
                              </p>

                              <p>
                                <strong>Zone: </strong>
                                {formData?.inputData?.invoice?.zone
                                  ?.zone_name || "-"}
                              </p>

                              <p>
                                <strong>Branch: </strong>
                                {formData?.inputData?.invoice?.branch
                                  ?.branch_name || "-"}
                              </p>
                            </Col>

                            <Col md="4">
                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.invoice?.status === 1
                                  ? "Courier Pending"
                                  : formData?.inputData?.invoice?.status === 2
                                    ? "Courier Completed"
                                    : "-"}
                              </p>

                              <p>
                                <strong>Outgoing Invoice Date: </strong>
                                {loadingData
                                  ? "-"
                                  : formatDate(
                                      formData?.inputData?.invoice
                                        ?.invoice_date ||
                                        formData?.inputData?.invoice
                                          ?.createdAt,
                                    ) || "-"}
                              </p>
                              <p>
                                <strong>Invoiced By: </strong>
                                {formData?.inputData?.invoice?.created_user
                                  ?.full_name || "-"}
                              </p>
                            </Col>

                            {formData?.inputData?.invoice?.status === 2 ? (
                              <Col md="4">
                                <p>
                                  <strong>Courier Name: </strong>
                                  {formData?.inputData?.invoice?.courier_name ||
                                    "-"}
                                </p>

                                <p>
                                  <strong>Courier Docket No: </strong>
                                  {formData?.inputData?.invoice
                                    ?.courier_docket_number || "-"}
                                </p>

                                <p>
                                  <strong>Courier Docket Date: </strong>
                                  {formatDate(
                                    formData?.inputData?.invoice
                                      ?.courier_docket_date,
                                  )}
                                </p>
                              </Col>
                            ) : (
                              <Col md="4">
                                {/* courier details are captured from the
                                    separate Courier menu, not from here */}
                                <p className="text-muted">
                                  Courier details are not added yet. Add them
                                  from the <strong>Courier</strong> menu.
                                </p>
                              </Col>
                            )}
                          </Row>
                        </div>
                        <div className="card-body">
                          {/* ================= DISPATCH LIST ================= */}
                          <h5 className="fw-bold mb-2">Dispatch Details</h5>

                          {formData?.inputData?.dispatches?.map(
                            (dispatch, index) => (
                              <div
                                key={index}
                                className="mb-4 p-3 border rounded shadow-sm"
                                style={{ fontSize: "13px" }}
                              >
                                <h6 className="fw-semibold border-bottom pb-2 mb-3 text-primary">
                                  {dispatch.dispatched_no}
                                </h6>

                                <Row>
                                  <Col md="4">
                                    <p>
                                      <strong>Dispatch Date: </strong>
                                      {formatDate(dispatch?.dispatch_date)}
                                    </p>

                                    <p>
                                      <strong>Intake No: </strong>
                                      {dispatch?.intake?.intake_no || "-"}
                                    </p>
                                  </Col>

                                  <Col md="4">
                                    <p>
                                      <strong>Item Description: </strong>
                                      {dispatch?.intake?.material
                                        ?.descriptions || "-"}
                                    </p>

                                    <p>
                                      <strong>GMDS Code: </strong>
                                      {dispatch?.intake?.material?.gmds_code ||
                                        dispatch?.intake?.material?.name ||
                                        "-"}
                                    </p>
                                  </Col>

                                  <Col md="4">
                                    <p>
                                      <strong>Serial No: </strong>
                                      {dispatch?.intake?.material_serial_no ||
                                        "-"}
                                    </p>
                                    <p>
                                      <strong>Job Card No: </strong>
                                      {dispatch?.job_card?.job_card_no || "-"}
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            ),
                          )}
                        </div>
                      </div>
                    </AvForm>

                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default OutgoingInvoicesView;
